import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUtensils } from "@fortawesome/pro-light-svg-icons"

import { MERCHANT_ADMIN_ROUTE, MERCHANT_MENU_PLANNING_TEMPLATE_CREATE_ROUTE } from "../../../../../constants/routes"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { StandardButton } from "../../../../../shared/components/buttons/StandardButton"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { MenuTemplatesTab } from "../../../merchant/menuPlanning/templates/pages/MenuTemplatesTab"

/** The menu templates list, reachable from Administration > Settings > Menu planning. */
export function MerchantAdminMenuPlanning() {
    const navigate = useNavigate()

    return (
        <>
            <LocalizedStrict id="merchant-admin-menu-planning-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.MENU_PLANNING}
                    title="Menu planning"
                    icon={<FontAwesomeIcon icon={faUtensils} />}
                    rightElement={
                        <LocalizedStrict id="merchant-menu-templates-create-button">
                            <StandardButton onClick={() => navigate(MERCHANT_MENU_PLANNING_TEMPLATE_CREATE_ROUTE)}>
                                Create template
                            </StandardButton>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-settings-header">
                            <Breadcrumb>Settings</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-menu-planning">
                            <Breadcrumb>Menu planning</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <MenuTemplatesTab />
        </>
    )
}
